import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.selectKit.isExpanded}}
  {{yield}}
{{/if}}
*/
{
  "id": "cjAVVDx2",
  "block": "[[[41,[30,0,[\"selectKit\",\"isExpanded\"]],[[[1,\"  \"],[18,1,null],[1,\"\\n\"]],[]],null]],[\"&default\"],false,[\"if\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/select-kit/select-kit-body.hbs",
  "isStrictMode": false
});